export enum InboxItemType {
  Billout = '5',
  Case = '6',
  Claim = '1',
  Document = '2',
  Invoice = '4',
  Quote = '3',
}

export const InboxTypeItemPathConstants: Record<InboxItemType, string> = {
  [InboxItemType.Billout]: 'billout',
  [InboxItemType.Case]: 'Case',
  [InboxItemType.Claim]: 'claim',
  [InboxItemType.Document]: 'document',
  [InboxItemType.Invoice]: 'invoice',
  [InboxItemType.Quote]: 'quotes',
}

export const InboxTypeItemLabels: Record<InboxItemType, string> = {
  [InboxItemType.Billout]: 'Bill Out',
  [InboxItemType.Case]: 'Case',
  [InboxItemType.Claim]: 'Claim',
  [InboxItemType.Document]: 'Document',
  [InboxItemType.Invoice]: 'Invoice',
  [InboxItemType.Quote]: 'Quotes',
}
